import { createReducer } from '@reduxjs/toolkit';

import { readMessagesSuccess } from 'modules/chat/actions';
import { MESSAGE_RECEIVED_FROM_SOCKET, REACTION_RECEIVED_FROM_SOCKET, REACTION_REMOVED_FROM_SOCKET } from 'modules/websockets/actionTypes';
import { isCreatedByMyself } from 'common/Messages/utils';
import { FETCH_MESSAGES_SUCCESS, FETCH_NEXT_MESSAGES_SUCCESS } from 'modules/chat/actionTypes';

/**
 * @typedef {{[messageId: string]: import('types/Messages').Message}} ByIdState
 */

/** @type {ByIdState} */
const initialState = {};

/**
 * @param {ByIdState} state
 * @param {import('modules/websockets/types').MessageReceivedAction} action
 * @returns {ByIdState}
 */
const setFromSocket = (state, { payload: data }) => ({
  ...state,
  [data.message.id]: isCreatedByMyself(data.message)
    ? { ...data.message, unread: false }
    : data.message,
});

/**
 * @param {ByIdState} state
 * @param {import('modules/websockets/types').MessageReceivedAction} action
 * @returns {ByIdState}
 */
const markAllRead = (state) =>
  Object.fromEntries(Object.entries(state).map(([id, msg]) => [id, { ...msg, unread: false }]));

const updateFromSocket = (state, { payload: data }) => ({
  ...state,
  [data.message.id]: {
    ...state[data.message.id],
    ...data.message,
    reactions: data.message.reactions // Ensure reactions IS overridden if it was emptied
  },
});

export default createReducer(initialState, (builder) => {
  builder
    .addCase(MESSAGE_RECEIVED_FROM_SOCKET, setFromSocket)
    .addCase(REACTION_REMOVED_FROM_SOCKET, updateFromSocket)
    .addCase(REACTION_RECEIVED_FROM_SOCKET, updateFromSocket)
    .addCase(FETCH_MESSAGES_SUCCESS, (_, { payload: { messages = [] } }) =>
      messages.reduce((acc, message) => ({ ...acc, [message.id]: message }), {}))
    .addCase(FETCH_NEXT_MESSAGES_SUCCESS, (state, { payload: { messages = [] } }) =>
      messages.reduce((acc, message) => ({ ...acc, [message.id]: message }), state))
    .addMatcher(readMessagesSuccess.match, markAllRead);
});
